import btnStyle from '@/components/Shares/Button.module.css';
import inputStyle from '@/components/Shares/Input.module.css';
import { useLingui } from '@lingui/react';
import { Box, Button, Input, Stack, Text } from '@mantine/core';
export const AsideRain: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <form>
      <Stack>
        <Box>
          <Text fw={700} fz={11} c="var(--text-prime)" tt="uppercase" mb={4}>
            {i18n._('Amount')}
          </Text>
          <Input h={40} placeholder="$2" classNames={{
          input: inputStyle.input_style_2
        }} />
        </Box>

        <Box>
          <Text fw={700} fz={11} c="var(--text-prime)" tt="uppercase" mb={4}>
            {i18n._('Persons')}
          </Text>
          <Input h={40} placeholder="50" classNames={{
          input: inputStyle.input_style_2
        }} />
        </Box>

        <Box>
          <Text fw={700} fz={11} c="var(--text-prime)" tt="uppercase" mb={4}>
            {i18n._('Message')}
          </Text>
          <Input h={40} placeholder="Add your message" classNames={{
          input: inputStyle.input_style_2
        }} />
        </Box>

        <Button h={40} tt="uppercase" fz={11} classNames={{
        root: btnStyle.root
      }}>
          {i18n._('Start Rain')}
        </Button>
      </Stack>
    </form>;
};